<template> 
  <div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <name id="name" width=75 height="49" v-bind:style=" { color: foregroundColor } "></name>
    <name-apostrophe id="name_apostrophe" width=75 height="49" v-bind:style=" { color: apostropheColor } "></name-apostrophe>
    <div class="boxes">
      <i class="fa fa-github" v-bind:style=" { color: foregroundColor } " style="font-size: 30px;" v-on:click="openInNewTab('https://github.com/williamorosky')" ></i>
      <i class="fa fa-linkedin-square" v-bind:style=" { color: foregroundColor } " style="font-size: 30px;" v-on:click="openInNewTab('https://www.linkedin.com/in/williamorosky')"></i>
      <i class="fa fa-twitter" v-bind:style=" { color: foregroundColor } " style="font-size: 30px;" v-on:click="openInNewTab('https://twitter.com/williamorosky')"></i>
      <i class="fa fa-instagram" v-bind:style=" { color: foregroundColor } " style="font-size: 30px;" v-on:click="openInNewTab('https://www.instagram.com/williamorosky/')"></i>
    </div>
    <div id="apostrophe"></div>
    <h3 id="caption" v-bind:style=" { color: foregroundColor } "></h3>
  </div>
</template>

<script>
import Name from '../components/Name.vue'
import NameApostrophe from '../components/NameApostrophe.vue'
// import { db, imagesRef } from '../main'

export default {
  name: 'Main',
  data () {
    return {
      foregroundColor: "#ffffff",
      apostropheColor: "#9786F9"
    }
  },
  // firestore () {
  //   return {
  //     images: db.collection('images')
  //   }
  // },
  components: {
    Name,
    NameApostrophe
  },
  methods: {
    openInNewTab: function (url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    // getFirstImage: function() {
    //     var dummy = {
    //         date: "January 1, 2019",
    //         backgound_link: "",
    //         apostrophe_link: "",
    //         apostrophe_color: "#ffffff",
    //         foreground_color: "#ffffff"
    //     }
    //     if (this.images[0] === -1) {
    //         return dummy.foreground_color
    //     } else {
    //         return this.images[0].foreground_color
    //     }
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  /* Location of the image */
  background-image: url(../assets/background.svg);
  
  /* Image is centered vertically and horizontally at all times */
  background-position: center center;
  
  /* Image doesn't repeat */
  background-repeat: no-repeat;
  
  /* Makes the image fixed in the viewport so that it doesn't move when 
     the content height is greater than the image height */
  background-attachment: fixed;
  
  /* This is what makes the background image rescale based on its container's size */
  background-size: cover;
  
  /* Pick a solid background color that will be displayed while the background image is loading */
  background-color:#464646;

  overflow: hidden;
}

.fa {
  float: right;
  margin: 15px 18px 0px 18px;
}

#name {
  position: absolute;
  margin: 15px 18px 0px 18px;
  max-width: 75px;
}

#name_apostrophe {
  margin: 15px 18px 0px 18px;
  max-width: 75px;
}

#apostrophe {
	width: 100%;
  height: 110vh;
  background:url(../assets/apostrophe.svg) no-repeat center center;
  background-attachment: fixed;
  background-size: cover;
}

#caption {
  /* font-family: "Gobold";
  padding-top: 20px;
	float: bottom;
  text-align: center; */

  position: absolute;
  font-family: "Gobold";
  text-align: center;
  font-size: 28px;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.boxes {
  display: inline;
  z-index: 6;
}

@media screen and (max-width: 600px) {
  .boxes {
    float: right;
    max-width: 25px;
    display: inline;
    z-index: 6;
  }
}
</style>